// SEO Destination and Route Data
import { ROUTE_DATA } from './routesData';
// Easy to scale - just add more entries to these arrays

export const DESTINATIONS = [
  {
    slug: 'sofia',
    city: 'Sofia',
    country: 'Bulgaria',
    airport: 'Sofia Airport (SOF)',
    iataCode: 'SOF',
    title: 'Sofia Airport Transfer | Private Airport Transfers',
    description: 'Book a private airport transfer from Sofia Airport to your hotel or destination. Professional drivers, fixed pricing and reliable service.',
    heroImage: '/images/sofia.jpg',
    popularRoutes: ['Bansko', 'Plovdiv', 'Borovets', 'City Center'],
    distance: { center: '10 km', time: '20 min' },
    faqs: [
      { q: 'How far is Sofia Airport from the city center?', a: 'Sofia Airport is approximately 10 km from the city center, about 20-30 minutes by car depending on traffic.' },
      { q: 'Are there transfers available to ski resorts?', a: 'Yes, we offer transfers from Sofia Airport to popular ski resorts including Bansko, Borovets, and Pamporovo.' },
      { q: 'What vehicles are available?', a: 'We offer Standard sedans, Business class vehicles, minivans for groups, and coaches for large parties.' }
    ]
  },
  {
    slug: 'london',
    city: 'London',
    country: 'United Kingdom',
    airport: 'London Heathrow Airport (LHR)',
    iataCode: 'LHR',
    title: 'London Airport Transfer | Private Airport Transfers',
    description: 'Book a private airport transfer from London Heathrow, Gatwick, Stansted or Luton to your destination. Meet & greet service included.',
    heroImage: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=1200',
    popularRoutes: ['Central London', 'Oxford', 'Cambridge', 'Brighton'],
    distance: { center: '24 km', time: '45 min' },
    faqs: [
      { q: 'Which London airports do you serve?', a: 'We serve all London airports including Heathrow (LHR), Gatwick (LGW), Stansted (STN), Luton (LTN), and London City (LCY).' },
      { q: 'Is meet & greet service included?', a: 'Yes, our drivers will meet you in the arrivals hall with a name board and assist with your luggage.' },
      { q: 'How long does it take to reach Central London?', a: 'From Heathrow, it takes approximately 45-60 minutes to Central London depending on traffic.' }
    ]
  },
  {
    slug: 'paris',
    city: 'Paris',
    country: 'France',
    airport: 'Paris Charles de Gaulle Airport (CDG)',
    iataCode: 'CDG',
    title: 'Paris Airport Transfer | Private Airport Transfers',
    description: 'Book a private airport transfer from Paris CDG or Orly Airport to your hotel. Professional chauffeurs and comfortable vehicles.',
    heroImage: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200',
    popularRoutes: ['Eiffel Tower', 'Champs-Élysées', 'Disneyland Paris', 'Versailles'],
    distance: { center: '25 km', time: '40 min' },
    faqs: [
      { q: 'Which Paris airports do you cover?', a: 'We provide transfers from both Charles de Gaulle (CDG) and Orly (ORY) airports.' },
      { q: 'Do you offer transfers to Disneyland Paris?', a: 'Yes, we offer direct transfers from Paris airports to Disneyland Paris, approximately 40 minutes from CDG.' },
      { q: 'Are child seats available?', a: 'Yes, child seats and booster seats are available upon request at no extra charge.' }
    ]
  },
  {
    slug: 'dubai',
    city: 'Dubai',
    country: 'United Arab Emirates',
    airport: 'Dubai International Airport (DXB)',
    iataCode: 'DXB',
    title: 'Dubai Airport Transfer | Private Airport Transfers',
    description: 'Book a luxury private airport transfer from Dubai International Airport. Premium vehicles and professional chauffeurs.',
    heroImage: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1200',
    popularRoutes: ['Burj Khalifa', 'Palm Jumeirah', 'Dubai Marina', 'Abu Dhabi'],
    distance: { center: '15 km', time: '20 min' },
    faqs: [
      { q: 'How far is Dubai Airport from Downtown Dubai?', a: 'Dubai International Airport is approximately 15 km from Downtown Dubai, about 20-25 minutes by car.' },
      { q: 'Do you offer luxury vehicles?', a: 'Yes, we offer a range of luxury vehicles including Mercedes S-Class, BMW 7 Series, and luxury SUVs.' },
      { q: 'Are transfers available to Abu Dhabi?', a: 'Yes, we provide transfers from Dubai Airport to Abu Dhabi, approximately 1.5 hours journey.' }
    ]
  },
  {
    slug: 'zurich',
    city: 'Zurich',
    country: 'Switzerland',
    airport: 'Zurich Airport (ZRH)',
    iataCode: 'ZRH',
    title: 'Zurich Airport Transfer | Private Airport Transfers',
    description: 'Book a private airport transfer from Zurich Airport to your hotel or ski resort. Reliable service to all Swiss destinations.',
    heroImage: 'https://images.unsplash.com/photo-1515488764276-beab7607c1e6?w=1200',
    popularRoutes: ['St. Moritz', 'Zermatt', 'Lucerne', 'Interlaken'],
    distance: { center: '12 km', time: '15 min' },
    faqs: [
      { q: 'Do you offer transfers to Swiss ski resorts?', a: 'Yes, we provide transfers from Zurich Airport to all major Swiss ski resorts including St. Moritz, Zermatt, Verbier, and Davos.' },
      { q: 'How long does it take to reach St. Moritz?', a: 'The transfer from Zurich Airport to St. Moritz takes approximately 2.5-3 hours depending on road conditions.' },
      { q: 'Are winter tires mandatory?', a: 'Yes, all our vehicles are equipped with winter tires from November to April for safe travel in alpine conditions.' }
    ]
  }
];

const HIGHLIGHTS = {
  ski: ['Ski and snowboard bags welcome', 'Meet & greet at arrivals', 'Flight tracking included', 'Door-to-door to your chalet or hotel'],
  beach: ['Straight to your hotel or apartment', 'Meet & greet at arrivals', 'Child seats available', 'Flight tracking included'],
  city: ['Door-to-door to any address', 'Meet & greet at arrivals', 'Flight tracking included', 'Fixed price, no surge pricing'],
  airport: ['Terminal-to-terminal service', 'Help with your luggage', 'Fixed price, no surge pricing', 'Flight tracking included'],
  family: ['Child seats available', 'Meet & greet at arrivals', 'Straight to your hotel or the park', 'Flight tracking included'],
};

export function formatDuration(minutes) {
  if (!minutes) return '';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (!h) return `about ${m} min`;
  return m ? `about ${h} h ${m} min` : `about ${h} h`;
}

function buildRoute(r) {
  const duration = formatDuration(r.durationMin);
  const car = (r.priceClass || 'standard').toLowerCase();
  const slowNote = r.category === 'ski' ? ' and mountain road conditions' : '';
  return {
    ...r,
    title: `${r.from} to ${r.to} Transfer from €${r.priceFrom}`,
    description: `Private transfer from ${r.from} to ${r.to}: ${r.distanceKm} km, ${duration}. Fixed price from €${r.priceFrom}, with meet & greet and flight tracking included.`,
    distance: `${r.distanceKm} km`,
    duration,
    highlights: HIGHLIGHTS[r.category] || HIGHLIGHTS.city,
    faqs: [
      { q: `How long is the transfer from ${r.from} to ${r.to}?`, a: `The route covers about ${r.distanceKm} km and usually takes ${duration}, depending on traffic${slowNote}.` },
      { q: `How much does a private transfer from ${r.from} to ${r.to} cost?`, a: `A private ${car} car starts from about €${r.priceFrom} one way. You see the exact fixed price for your date before you pay, and it doesn't change if your flight is late or the roads are busy.` },
      { q: 'Will the driver wait if my flight is delayed?', a: 'Yes. Your driver tracks your flight and meets you in arrivals with a name sign, and extra waiting time is included when a flight is delayed.' },
      { q: `What should I know about the trip to ${r.to}?`, a: r.tip },
    ],
  };
}

export const ROUTES = ROUTE_DATA.map(buildRoute);

// Routes that share the departure city first, then others in the same country.
export function relatedRoutes(route, limit = 6) {
  const others = ROUTES.filter(r => r.slug !== route.slug);
  const sameCity = others.filter(r => r.fromCity === route.fromCity);
  const sameCountry = others.filter(r => r.country === route.country && r.fromCity !== route.fromCity);
  return [...sameCity, ...sameCountry].slice(0, limit);
}

// Helper function to get destination by slug
export const getDestinationBySlug = (slug) => {
  return DESTINATIONS.find(d => d.slug === slug);
};

// Helper function to get route by slug
export const getRouteBySlug = (slug) => {
  return ROUTES.find(r => r.slug === slug);
};

// Get all destination slugs for sitemap
export const getAllDestinationSlugs = () => {
  return DESTINATIONS.map(d => `/airport-transfer/${d.slug}`);
};

// Get all route slugs for sitemap
export const getAllRouteSlugs = () => {
  return ROUTES.map(r => `/transfer/${r.slug}`);
};

export default { DESTINATIONS, ROUTES };
